import { Block } from '@/components/base/Block'
import { Text3 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import useIsMobile from '@/hooks/useMobile'
import borderRadius, { type BorderRadiusKeyType } from '@/styles/border_radius'
import { align } from '@/styles/display'
import { fontSize, fontWeight } from '@/styles/font'
import spaceStyle from '@/styles/space'

interface RecommendLabelProps {
  isShow?: boolean
  isAbsolute?: boolean
  rounded?: BorderRadiusKeyType | undefined
  isTransparent?: boolean
  top?: string | number
}

const RecommendLabel = ({
  isShow = false,
  isAbsolute = true,
  rounded = borderRadius.M,
  isTransparent = false,
  top
}: RecommendLabelProps): JSX.Element => {
  const app = useApp()
  const borderStyle = `1px solid rgba(0, 0, 0, 0.12)`
  const isMobile = useIsMobile()

  return isShow ? (
    <Block
      borderRadius={{
        upper: rounded
      }}
      textAlign={align.CENTER}
      backgroundColor={
        isTransparent ? app.theme.yellowTransparentColor : app.theme.yellowColor
      }
      style={{
        position: isAbsolute ? 'absolute' : 'unset',
        top,
        left: '0',
        width: '100%',
        borderTop: `${borderStyle}`,
        borderBottom: `${borderStyle}`
      }}
    >
      <Text3
        fontSize={isMobile ? fontSize.XXS : fontSize.S}
        fontWeight={fontWeight.Bold}
        margin={{ vertical: spaceStyle.NONE }}
        padding={{ vertical: spaceStyle.S }}
        textColor={app.theme.mainTextColor}
      >
        {'担当アドバイザーのおすすめ'}
      </Text3>
    </Block>
  ) : (
    <></>
  )
}

export default RecommendLabel
